export default "__VITE_ASSET__DmylKLId__"